import axios from 'axios';

import { MFA_METHODS } from 'constants/mfa';

/**
 * API call to verify the MFA code entered by the user.
 *
 * NOTE: this request is authorized with the short lived `mfa_token` instead of
 * the application's access token, and it must never go through the global
 * refresh token flow, since the API answers an invalid code with a `401`.
 *
 * @method verifyMFACodeAPI
 * @param  {Object}         params
 * @param  {string}         params.code     The code entered by the user
 * @param  {string}         [params.method] The MFA method being verified
 * @param  {string}         params.mfaToken The `mfa_token` from the authenticate response
 * @return {Promise}
 */
export const verifyMFACodeAPI = ({ code, method = MFA_METHODS.TOTP, mfaToken }) =>
    axios({
        data: {
            code,
            method,
        },
        headers: {
            Authorization: `Bearer ${mfaToken}`,
            'Content-Type': 'application/json',
        },
        ignoreAuthorization: true,
        method: 'POST',
        preventRefreshToken: true,
        url: '/v2/mfa/verify',
    });
